if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.addEventListener(
          'pointerup',
          (event) => {
            const button = this.getNavigationButtonFromEvent(event);
            if (!button) return;

            event.preventDefault();
            event.stopImmediatePropagation();
          },
          true
        );

        this.addEventListener('click', (event) => {
          const button = this.getNavigationButtonFromEvent(event);
          if (!button) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          this.showAdjacentMedia(button.dataset.dogmaModalNav === 'next' ? 1 : -1);
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showAdjacentMedia(1);
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showAdjacentMedia(-1);
          }
        });
      }

      getNavigationButtonFromEvent(event) {
        const target = event.target;

        if (!target || typeof target.closest !== 'function') return null;

        return target.closest('[data-dogma-modal-nav]');
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener ? opener.getAttribute('data-media-id') : null);
        this.updateNavigationButtons();
      }

      getMediaItems() {
        return Array.from(
          this.querySelectorAll('.product-media-modal__content [data-media-id]')
        );
      }

      showActiveMedia(mediaId) {
        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        const activeMedia =
          mediaItems.find((item) => item.dataset.mediaId === mediaId) || mediaItems[0];

        mediaItems.forEach((item) => {
          item.classList.toggle('active', item === activeMedia);
          item.setAttribute('aria-hidden', item === activeMedia ? 'false' : 'true');
        });

        this.loadDeferredMedia(activeMedia);
      }

      showAdjacentMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;

        const currentIndex = Math.max(
          mediaItems.findIndex((item) => item.classList.contains('active')),
          0
        );

        const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;

        this.showActiveMedia(mediaItems[nextIndex].dataset.mediaId);
      }

      loadDeferredMedia(mediaElement) {
        const deferredMedia = mediaElement.matches('deferred-media, product-model')
          ? mediaElement
          : mediaElement.querySelector('deferred-media, product-model');

        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent();
        }
      }

      updateNavigationButtons() {
        const shouldShow = this.getMediaItems().length > 1;

        this.querySelectorAll('[data-dogma-modal-nav]').forEach((button) => {
          button.hidden = !shouldShow;
        });
      }
    }
  );
}